import { render, staticRenderFns } from "./PopupAnnounce.vue?vue&type=template&id=5ce181e9"
import script from "./PopupAnnounce.vue?vue&type=script&lang=js"
export * from "./PopupAnnounce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports